import {
  SET_COPY,
  SET_COPY_PICKS_ONLY,
  SET_COPY_DRIVES_ONLY,
  RESET_CLIPBOARD
} from "./constants.js";

import clipboard from "../../../src/utils/nonReactiveState/clipboard.js";

export default {
  [SET_COPY](state, { indexes, values, rangeX, rangeY, driveTypes }) {
    clipboard.setCopy(indexes, values, rangeX, rangeY, driveTypes);
  },
  [SET_COPY_PICKS_ONLY](state, { pickIndexes, pickValues }) {
    clipboard.setCopyPicksOnly(pickIndexes, pickValues);
  },
  [SET_COPY_DRIVES_ONLY](state, { driveIndexes, driveValues, driveTypes }) {
    clipboard.setCopyDrivesOnly(driveIndexes, driveValues, driveTypes);
  },
  [RESET_CLIPBOARD]() {
    clipboard.resetClipboard();
  }
};
